// 判断是否为函数
export const isFunction = function (fn) {
    return Object.prototype.toString.call(fn) === '[object Function]';
};

// 获取元素在数组中的位置，没有则返回-1
export const inArray = function(item, arr) {
    for (let i = 0; i < arr.length; i++) {
        if (item === arr[i]) {
            return i;
        }
    }
    return -1;
};

// 将秒格式化为时分秒对象
export const formateSecond = function(time) {
    if(time > 0) {
        let hour = ('00' + parseInt(time / 60 / 60)).slice(-2)
        let minute = ('00' + parseInt((time - hour*60*60)/60)).slice(-2)
        let second = ('00' + parseInt((time - hour*60*60 - minute*60))).slice(-2);
        return {
            hour: hour,
            minute: minute,
            second: second
        };
    }else{
        return {
            hour: '00',
            minute: '00',
            second: '00'
        };
    }
};

// 数组排序引用函数
export const sortNumber = function (a, b) {
    return a - b;
};

// 日期，在原有日期基础上，增加days天数，默认增加1天
export const addDate = function(today, days, fomat) {
    if (days === undefined || days === '') {
        days = 1;
    }
    let date = new Date(today);
    date.setDate(date.getDate() + days);
    let month = date.getMonth() + 1;
    let day = date.getDate();
    return date.getFullYear() + fomat + getFormatDate(month) + fomat + getFormatDate(day);
};

// 日期月份/天的显示，如果是1位数，则在前面加上'0'
export const getFormatDate = function(arg) {
    if (arg === undefined || arg === '') {
        return '';
    }
    let re = arg + '';
    if (re.length < 2) {
        re = '0' + re;
    }
    return re;
}

/*
 * 设置cookie
 ** key 键值 type为操作类型 value为值 exdays为过期时间 删除cookie传入-1
 * 0为写入cookie
 * 1为获取cookie
 * 2为删除cookie
 * 3为清空cookie
*/
export function selfCookie(key, type, value, exdays) {
    switch (type) {
        case 0:
        case 2:
            let d = new Date();
            d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
            let expires = "expires=" + d.toGMTString();
            document.cookie = key + "=" + value + "; " + expires;
            break
        case 1:
            let name = key + "=";
            let ca = document.cookie.split(';');
            let re = ''
            for (let i = 0; i < ca.length; i++) {
                let c = ca[i].trim();
                if (c.indexOf(name) === 0) {
                    re = c.substring(name.length, c.length);
                    break
                }
            }
            return re
        case 3:
            let keys = document.cookie.match(/[^ =;]+(?=\=)/g)
            if (keys) {
                for (let i = keys.length; i--;) {
                    document.cookie = keys[i] + '=0;expires=' + new Date(0).toUTCString()
                }
            }
            break
    }
}


// WEBPACK FOOTER //
// src/js/public/common.js